import React from 'react';
import styled from 'styled-components';
import { submitCitationStream } from '@services/genaiQueriesV2';
import { logger } from '@utils/usefulFuncs';
import { CitationsModal } from '@features/modals/CitationsModal';
import { Body5 } from '@ui';
import { Answer } from '@containers/DigitalAnalyst/components/AnswerLine';
import { useTableResults } from '@hooks/features/useTableResults';
import { useStreamingResult } from '@hooks/features/useStreamingResult';
import { useSelector } from 'react-redux';

const AnswerWrapper = styled.div`
  position: relative;
  margin-top: -16px;
  overflow-x: auto;
`;
const CellWrapper = styled.td``;

export function CellAnswer({ data: cellData, tool, showCitations, isLastCellInRow }) {
  const { cellIndex, rowIndex, groupResultId, childResultId, sourceDocs, isDiffModeRow } = cellData;

  const isGettingCitationsRef = React.useRef(false);

  const [shouldGetCitations, setShouldGetCitations] = React.useState(false);
  const [citationsResultId, setCitationsResultId] = React.useState(null);
  const [isGettingCitations, setIsGettingCitations] = React.useState(false);
  const [highlightContextItem, setHighlightContextItem] = React.useState(null);

  const cellResultId = `${groupResultId}_${rowIndex}_${cellIndex}`;
  const result = useTableResults(cellResultId);
  const completedResultsLookup = useSelector((state) => state.gridTableResults.completedResultsLookup);
  const isAnswerStreamComplete = completedResultsLookup[groupResultId];

  const { result: citationsStreamingResult, context: streamingCitationsContext } =
    useStreamingResult(citationsResultId);

  const onCitationClick = (chunkId, doc) => {
    logger({ chunkId, doc }, streamingCitationsContext);
    setHighlightContextItem({ chunkId, doc });
  };

  const onCitationDismiss = () => {
    setHighlightContextItem(null);
  };

  React.useEffect(() => {
    if (showCitations && !shouldGetCitations) {
      setShouldGetCitations(true);
    }
  }, [showCitations, shouldGetCitations]);

  React.useEffect(() => {
    const getCitations = async () => {
      setIsGettingCitations(true);
      const result = await submitCitationStream({ queryRunId: childResultId });
      setIsGettingCitations(false);
      if (result.status === 200 && !result.error && result.runId) {
        setCitationsResultId(result.runId);
      } else {
        setTimeout(() => {
          getCitations();
        }, 2000);
      }
    };
    if (shouldGetCitations && isAnswerStreamComplete && !isGettingCitationsRef.current) {
      isGettingCitationsRef.current = true;
      getCitations();
    }
  }, [shouldGetCitations, isAnswerStreamComplete, isGettingCitationsRef]);

  if (isLastCellInRow && isDiffModeRow) {
    return (
      <CellWrapper className={'response'}>
        <Body5>
          <AnswerWrapper></AnswerWrapper>
        </Body5>
      </CellWrapper>
    );
  }

  return (
    <CellWrapper className={'response'}>
      {highlightContextItem !== null && (
        <CitationsModal item={highlightContextItem} context={streamingCitationsContext} onDismiss={onCitationDismiss} />
      )}
      <Body5>
        <AnswerWrapper>
          <Answer
            // isAddingCitations={isGettingCitations}
            isShowingCitations={!!citationsResultId}
            onCitationClick={onCitationClick}
            result={citationsResultId ? citationsStreamingResult : result}
            sourceDocs={sourceDocs}
          />
        </AnswerWrapper>
      </Body5>
    </CellWrapper>
  );
}
